var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconDog = function SvgIconDog(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m19.467 4.23-3.477.867 4.778 6.08zm-.229-2.003a1.75 1.75 0 0 1 2.143 1.356l.002.011 1.537 8.213v.004c.27 1.475-1.244 2.453-2.42 1.935v3.504a4 4 0 0 1-4 4h-9a4 4 0 0 1-4-4v-3.504c-1.177.518-2.691-.46-2.422-1.935l.001-.005 1.538-8.212.002-.01A1.75 1.75 0 0 1 4.76 2.226h.002L9.873 3.5h4.254l5.11-1.273zM5.5 11.528v5.722a2 2 0 0 0 2 2H11v-.836l-1.207-1.207a1 1 0 0 1 1.414-1.414l.793.793.793-.793a1 1 0 0 1 1.414 1.414L13 18.414v.836h3.5a2 2 0 0 0 2-2v-5.722L13.764 5.5h-3.528zm4.625 1.222a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m5.25 1.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M3.232 11.178l1.3-6.947 3.477.866z",
    clipRule: "evenodd"
  })));
};
export default SvgIconDog;